import { InputUnstyled } from "@mui/base";
import styled from "styled-components";
const TextInput = styled(InputUnstyled)`
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  overflow: hidden;
  input {
    display: block;
    width: 100%;
    border: none;
    background-color: transparent;
    padding: 8px 12px;
    outline: none;
  }
  input:focus {
    background-color: white;
  }
`;
export default TextInput;
